import Api from "@/services/api";
import { FETCH_DEFAULT_FEATURE_CONFIG } from "@/store/_actiontypes";
import {
  SET_DEFAULT_FEATURE_ACCESS_CONFIG,
  SET_DEFAULT_FEATURE_ACCESS_ERROR,
  SET_DEFAULT_FEATURE_ACCESS_LOADING,
} from "@/store/_mutationtypes";

const getDefaultState = () => ({
  isDefaultFeatureLoading: false,
  defaultFeatureError: null,
  isFetched: false,
  defaultFeatureConfig: {},
});

const state = getDefaultState();

const getters = {
  defaultFeatureConfig: state => state.defaultFeatureConfig,
  featureAccessLoading: state => state.isDefaultFeatureLoading,
  featureAccessFetched: state => state.isFetched,
};

const actions = {
  async [FETCH_DEFAULT_FEATURE_CONFIG]({state,  commit }) {
     if (state.isFetched || state.isDefaultFeatureLoading) {
      return;
    }
    commit(SET_DEFAULT_FEATURE_ACCESS_LOADING, true);
    commit(SET_DEFAULT_FEATURE_ACCESS_ERROR, null);
    try {
      const response = await Api.get("projects/default/permission");

      const features = response?.data?.features;
      if (features && typeof features === 'object') {
        commit(SET_DEFAULT_FEATURE_ACCESS_CONFIG, features);
      } else {
        throw new Error('Invalid feature config response');
      }

      return response;
    } catch (error) {
      commit(SET_DEFAULT_FEATURE_ACCESS_ERROR, error);
      console.error(error);
      throw error;
    } finally {
      commit(SET_DEFAULT_FEATURE_ACCESS_LOADING, false);
    }
  },
};

const mutations = {
  [SET_DEFAULT_FEATURE_ACCESS_CONFIG](state, payload) {
    state.defaultFeatureConfig = payload || {};
    state.isFetched = true;
  },
  [SET_DEFAULT_FEATURE_ACCESS_LOADING](state, payload) {
    state.isDefaultFeatureLoading = payload;
  },
  [SET_DEFAULT_FEATURE_ACCESS_ERROR](state, payload) {
    state.defaultFeatureError = payload;
  },
};

export const featureAccess = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
